import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import webCore from '@happylife-a/web-core';

const MotionBox = motion(Box);
const MotionText = motion(Text);

export default function ProgressBar({ progress }) {
  const { t } = webCore.contexts.useTranslation();

  return (
    <Box w="100%" maxW="400px">
      <MotionBox
        w="100%"
        h="8px"
        bg="whiteAlpha.200"
        borderRadius="full"
        overflow="hidden"
        position="relative"
      >
        <MotionBox
          h="100%"
          bg="white"
          borderRadius="full"
          initial={{ width: '0%' }}
          animate={{ width: `${progress}%` }}
          transition={{
            duration: 0.3,
            ease: 'easeOut',
          }}
        />
        {/* Shimmer effect */}
        <MotionBox
          position="absolute"
          top={0}
          left={0}
          w="30px"
          h="100%"
          bg="linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)"
          animate={{
            x: ['-30px', '100%'],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'linear',
          }}
        />
      </MotionBox>
      <MotionText
        color="white"
        fontSize="xs"
        textAlign="center"
        mt={2}
        opacity={0.8}
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.8 }}
        transition={{ delay: 0.5 }}
      >
        {Math.round(progress)}% {t('Complete')}
      </MotionText>
    </Box>
  );
}
